module.exports = __webpack_public_path__ + "static/img/icon-clientuser.9782be4a.svg";